import type { FaireProductEntity } from "../../entity_types/product";

export const p_k33skrrqn5: FaireProductEntity = {
  token: "p_k33skrrqn5",
  type: "product",
  name: 'CATHEDRAL - AMETHYST UNIQUE 6-26" (KG)',
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/f9efc9c0757455d7a6d74349c58fcd329fb967d44eea8d26ed0cae199afd04de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/309b1a6e582ead2b8f43d50d9aa20c702eac0ee04740282f22d0e8d2ee25fdbd.jpeg",
    "https://cdn.faire.com/fastly/7416c67d926e03bb5acc81c34194eb03770133bd36b0614da268be5a70dac98c.jpeg",
    "https://cdn.faire.com/fastly/8e220ade186da55293e4656625eacd538f251ecbe3e9ed7a4a2adb5c0a72de8e.jpeg",
  ],
  priceDollars: 55.84,
  description:
    'Unearth the power of spiritual stones with our unique Cathedral - Amethyst, ranging from 6-26". Brought to you by Oceanic Linkways Inc, a leader in gemstones and spiritual gifts since 1991. Our Amethyst is sourced from 19 different countries, ensuring a diverse range of energy and healing properties. Ideal for those seeking balance and tranquility. Elevate your wellness routine with the soothing power of our meticulously selected Amethyst.',
  tags: [],
  msrpDollars: 223.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:49.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
